/**
 * API 521 Table 1 과압 시나리오 17종 로더.
 *
 * 원본: /data/api521-scenarios.json (페이지 이미지 판독, PDF 25~26쪽)
 * 데이터 수정 시 `python data/verify-api521.py` 재실행.
 */
import raw from "../../data/api521-scenarios.json";
import type { ContingencyKind } from "../calc/governingCase";

export interface ScenarioSubItem {
  readonly label: string;
  readonly condition: string;
  readonly conditionKo: string;
  readonly section: string;
}

export interface ScenarioDefinition {
  readonly item: number;
  readonly condition: string;
  readonly conditionKo: string;
  readonly section: string;
  /**
   * 소요 유량을 어떻게 얻는가.
   *  formula   — 표준에 계산식이 있음 (13 열팽창, 14 화재, 15 튜브 파열)
   *  userInput — 열·물질수지 필요, 설계자가 직접 입력
   *  caseBased — 케이스별 개별 분석
   *  notPrd    — 안전밸브 대상이 아님 (11 내부 폭발)
   *  tbd       — 조항 확인 필요
   */
  readonly relievingRate: "formula" | "userInput" | "caseBased" | "notPrd" | "tbd";
  readonly note?: string;
  readonly subItems?: readonly ScenarioSubItem[];
}

export const API_521_SCENARIOS: readonly ScenarioDefinition[] =
  raw.scenarios as readonly ScenarioDefinition[];

/** 14번 외부 화재만 화재 상황으로 취급한다 (허용 과압 21 %). */
export const FIRE_SCENARIO_ITEM = 14;

/** 시나리오 항목 번호에 대한 기본 상황 구분. */
export function defaultContingency(item: number): ContingencyKind {
  return item === FIRE_SCENARIO_ITEM ? "fire" : "operating";
}

/** 11번 내부 폭발은 일반 PRD 로 대응하는 대상이 아니다 (API 521 Table 1). */
export function isNotPrdScenario(item: number): boolean {
  return API_521_SCENARIOS.find((s) => s.item === item)?.relievingRate === "notPrd";
}

export function findScenario(item: number): ScenarioDefinition | undefined {
  return API_521_SCENARIOS.find((s) => s.item === item);
}

/** 드롭다운에 쓸 표시명. 예: "14. 외부 화재 (4.4.13)" */
export function scenarioLabel(s: ScenarioDefinition): string {
  return `${s.item}. ${s.conditionKo} (${s.section})`;
}
